// import type { PolicyEntity } from '@/shared/entities/PolicyEntity'

import type { PolicyEntity } from '@/shared/entities/PolicyEntity'

/**
 * Represents the data for updating an authorization base role.
 *
 * @remarks
 * This class is used to encapsulate the properties of an authorization base role that can be updated.
 */
export class UpdateBaseRoleEntity {
  /**
   * The policies associated with the base role.
   */
  policies?: PolicyEntity[]
}
